import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './GradeSelector.css';

function GradeSelector({ onGradeSelect, isAdminsky }) {
  const [availableGrades, setAvailableGrades] = useState([]);
  const [loading, setLoading] = useState(true);

  // High-school grades plus a virtual entry for junior high (7-9)
  const gradeConfig = [
    {
      grade: 'junior-high',
      name: 'שכבות ז׳-ט׳',
      icon: '🎒',
      description: 'משחקים מותאמים לחטיבת הביניים',
      color: '#607D8B',
      route: '/junior-high'
    },
    {
      grade: 'grade10',
      name: 'שכבה י׳',
      icon: '📒',
      description: 'משחקים מותאמים לשכבה י׳',
      color: '#4CAF50'
    },
    {
      grade: 'grade11',
      name: 'שכבה י״א',
      icon: '🖊️',
      description: 'משחקים מותאמים לשכבה י״א',
      color: '#FF9800'
    },
    {
      grade: 'grade12',
      name: 'שכבה י״ב',
      icon: '🎓',
      description: 'משחקים מותאמים לשכבה י״ב',
      color: '#E91E63'
    }
  ];

  useEffect(() => {
    const checkAvailableGrades = async () => {
      const availableGradesList = [];

      for (const gradeInfo of gradeConfig) {
        // Always show virtual entries (like the combined 7-9 box)
        if (gradeInfo.route) {
          availableGradesList.push(gradeInfo);
          continue;
        }

        try {
          // Basic check to ensure files are reachable; fall back to showing anyway
          const response = await fetch(`/words-${gradeInfo.grade}-test.csv`);
          if (response.ok) {
            availableGradesList.push(gradeInfo);
          } else {
            availableGradesList.push(gradeInfo);
          }
        } catch (error) {
          availableGradesList.push(gradeInfo);
        }
      }

      setAvailableGrades(availableGradesList);
      setLoading(false);
    };

    checkAvailableGrades();
  }, []);

  const handleGradeSelect = (gradeInfo) => {
    if (gradeInfo.route) return; // virtual entry handled by Link route
    onGradeSelect(gradeInfo.grade, gradeInfo.name);
  };

  if (loading) {
    return (
      <div className="grade-selector">
        <div className="grade-selector-container">
          <h2>טוען שכבות...</h2>
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="grade-selector">
      <div className="grade-selector-container">
        <h2>משחקי תרגול</h2>
        <p className="grade-selector-subtitle">בחר את השכבה המתאימה</p>
        
        <div className="grades-grid">
          {availableGrades.map((gradeInfo, index) => (
            <Link 
              key={index}
              to={gradeInfo.route || `/grade/${gradeInfo.grade}`}
              className="grade-card"
              onClick={() => handleGradeSelect(gradeInfo)}
              style={{ '--grade-color': gradeInfo.color, textDecoration: 'none', color: 'inherit' }}
            >
              <div className="grade-icon">{gradeInfo.icon}</div>
              <h3 className="grade-name">{gradeInfo.name}</h3>
              <p className="grade-description">{gradeInfo.description}</p>
            </Link>
          ))}
        </div>

        {isAdminsky && (
          <div className="add-grade-info">
            <h4>רוצה להוסיף נושא חדש?</h4>
            <p>Create a new CSV file in the public/ folder containing 20 Arabic words in column A and 20 Hebrew translations in column B. Name the file according to topic and grade, for example:</p>
            <p><strong>words-grade10-[topic].csv</strong> for grade 10</p>
            <p><strong>words-grade11-[topic].csv</strong> for grade 11</p>
          </div>
        )}
        
        {!isAdminsky && (
          <div className="developer-info-link">
            <Link to="/adminsky" style={{ 
              fontSize: '16px', 
              color: 'rgba(255, 255, 255, 0.3)',
              textDecoration: 'none'
            }}>
              מידע למפתחים
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default GradeSelector;
